export const getOption = (options, value) => options.find(option => option.value === value) || null;